import isArray from 'lodash/isArray'

import { ObjectDataRecord, TimelineCellMove, TimeLineGridDataRecord } from '@types'

export function applyTimelineCellMovesToRows(
  prev: TimeLineGridDataRecord[],
  moves: TimelineCellMove[],
  pkName: string
): TimeLineGridDataRecord[] {
  const touchedRowIds = new Set(moves.flatMap(m => [m.sourceRowId, m.targetRowId]))

  return prev.map(row => {
    if (!touchedRowIds.has(row.id)) {
      return row
    }

    const cloned = structuredClone(row)

    for (const move of moves) {
      if (move.sourceRowId === row.id && isArray(cloned[move.sourceColumnId])) {
        cloned[move.sourceColumnId] = (cloned[move.sourceColumnId] as ObjectDataRecord[]).filter(
          (e: ObjectDataRecord) => e[pkName] !== move.item[pkName]
        )
      }

      if (move.targetRowId === row.id) {
        if (!isArray(cloned[move.targetColumnId])) {
          cloned[move.targetColumnId] = [] as ObjectDataRecord[]
        }

        const columnInfo =
          (cloned.columnsInfo?.[move.targetColumnId] as ObjectDataRecord | undefined) || {}

        const existing = cloned[move.targetColumnId] as ObjectDataRecord[]
        const itemPk = move.item[pkName]
        const alreadyHas = existing.some((e: ObjectDataRecord) => e[pkName] === itemPk)

        if (!alreadyHas) {
          cloned[move.targetColumnId] = [...existing, { ...move.item, columnInfo }]
        }
      }
    }

    return cloned
  })
}
